import { useTranslation } from 'react-i18next';

import IllustratedEmptyState from './IllustratedEmptyState';

export default function DisplayNoSelectedResults() {
  const { t } = useTranslation();

  return (
    <IllustratedEmptyState
      imageSrc="svg/NoSelectedResult_ez_transparent.svg"
      imageAlt="no_selected_results"
      imageDataQaElementId="no_selected_results_image"
      message={t('filter.noSelectedRows')}
      messageDataQaElementId="no_selected_results_text"
    />
  );
}
